
<!--
 * @Autor: 符应飞
 * @Date: 2021-10-30 11:29:54
 * @LastEditors: 符应飞
 * @Description: 目录首页 
 * @LastEditTime: 2025-08-14 10:01:39
-->

<template>
  <div>
      <!-- 标题 -->
      <!-- <van-nav-bar
        title="人脸识别"
        :fixed="true"
      /> -->

      <!-- 区分有没有人脸  -->

      <div class="img-container">

          <!-- 图片 -->
          <div class="img-container-image videostyle" :style="'background-image: url(' + faceInfo +');'" v-if="faceInfo">
          </div>
          <div class="img-container-image" v-else>
             <img src="@/assets/faceHome.png" alt="">
          </div>


          <!-- 提示 -->
          <div class="tip-container">
            <p>录入时请不要遮挡脸部</p>
          </div>
      </div>


       <!-- 录入按钮 -->
        <div class="btn-group" @click="toVerify">
            <button v-if="faceInfo">重新录入</button>
            <button v-else>人脸录入</button>
        </div>   

        <!-- 开始认证 -->
        <!-- <div class="btn-group" style="margin: 10px auto 30px;" @click="clickTab">
            <button>人脸登录</button>
        </div> -->

  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import {reqExistFace} from "@/api/verify"
import {mapState} from 'vuex'
import { removeToken } from '@/utils/auth'
export default {
  data() {
    return {
      // faceInfo: ''
    }
  },
  computed:{
    ...mapState(['token','faceInfo','userId', 'importStatus'])
  },
  mounted() {
    this.$nextTick(async () => {
      this.isExitFace()
      // 判断ios还是安卓
      // this.checkDevice()
    })
  },
  methods: {

    isExitFace() {

        this.$store.dispatch('getUserFace', this.token);
    //   reqExistFace({
    //     token:this.token
    //   }).then(res => {

    //     if(res.code ==0 ) {
    //       let faceInfo = res.exist==true? res.faceImg : '';
          
    //       this.$store.commit('SET_FACEINFO',faceInfo);
    //       // window.localStorage.setItem('faceInfo',faceInfo)
    //     } 
    //     // else {
    //     //   removeToken();
    //     //   this.$router.push('/login')
    //     // }
    //   })
    },
    toVerify2() {
      
      if(this.faceInfo) {
         this.$router.push('/update')    
      }else {
        this.$router.push('/verify')
      }
      
    },
    toVerify() {
      this.$router.push('/verify')
    },
    clickTab() {
      this.$router.push('/face')
    },
    // 判断ios还是安卓
    checkDevice() {
      let u = navigator.userAgent
      let device = '';
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;

      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      console.log('isAndroid', isAndroid)
      console.log('isIOS', isIOS)

      alert('isAndroid:', isAndroid)
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            //ios
           device = 'ios'
      } else if(/(Android)/i.test(navigator.userAgent)) {
            //android
           device = 'android'
      }  

      console.log('device',device)
      this.$store.commit('SET_DEVICE',device)
    }
  },
}
</script>
<style lang="less">
.version-view{
  position: fixed;
  bottom: 20px;
  left: 0;
  width: 100%;
  p{
    width: 100%;
    text-align: center;
    color: #ccc;
    font-size: 14px;
  }
}
  .img-container{
    padding-top: 2.1333rem;
    margin-top: .2667rem;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .img-container-image{
      width: 4.8rem;
      height: 4.8rem;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 50%;
      
      img{
        width: 4.8rem;
        height: 4.8rem;
      }
    }
    .tip-container{
      width: 100%;
      
      p{
        width: 80%;
        margin: 30px auto;
        text-align: center;
       font-size: 14px;
        color: #888;
      }
    }
  }
     .btn-group{
      width: 90%;
      margin: 20px auto 15px;
      background-color: #0077ff;
      button{
        width: 100%;
        height: 1.2rem;
        line-height: 1.2rem;
        font-size: 14px;
        color: #fff;
        background-color:#0077ff;
        border: none;
        padding: 0;
      }
    }

    .videostyle{
      transform: rotateY(180deg);
      -webkit-transform: rotateY(180deg);    /* Safari 和 Chrome */
      -moz-transform: rotateY(180deg);
    }
</style>